import { Component, OnInit, Input, Output , EventEmitter } from '@angular/core';
import { Teacher } from 'src/app/models/teacher.model';

@Component({
  selector: 'app-teacher-item',
  templateUrl: './teacher-item.component.html',
  styleUrls: ['./teacher-item.component.css']
})
export class TeacherItemComponent implements OnInit {
  
  @Input() teacher:Teacher = new Teacher()

  @Output() routeToTeacherDetail:EventEmitter<string> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    console.log(this.teacher)
  }

  routeToDetail(teacher){
     this.routeToTeacherDetail.emit(teacher.id);
  }
}
